import { Component, Input } from '@angular/core';
import { isExternalLink } from '@core-app/utils/link.util';

@Component({
    selector: 'core-block-ai-faq',
    templateUrl: './block-ai-faq.component.html',
    standalone: false,
})
export class BlockAiFaqComponent {
    @Input() faq!: {
        question: string;
        answer: string;
        actionUrl?: string;
    };

    isExternalLink(url: string | undefined): boolean {
        return isExternalLink(url);
    }
}
